import { Box, Center, Spinner } from '@chakra-ui/react';
import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import useColors from './useColors';
import ColorsToolbar from './Toolbar';
import ColorsModal from './Modal';

const ColorManagementTab = () => {
    const {
        isRetailersLoading,
        selectedType,
        colorToSubmit,
        setColorToSubmit,
        isColorsLoading,
        unsetColorsData,
        isUnsetColorsLoading,
        colorTypes,
        handleChangeColorType,
        table,
        handleOpenModal,
        modalType,
        isModalOpen,
        setIsModalOpen,
        showColorPicker,
        setShowColorPicker,
    } = useColors();

    return (
        <Box mt="16px">
            <ColorsToolbar
                {...{
                    table,
                    isColorsLoading,
                    isRetailersLoading,
                    isUnsetColorsLoading,
                    unsetColorsData,
                    selectedType,
                    handleChangeColorType,
                    handleOpenModal,
                    colorTypes,
                    setColorToSubmit,
                }}
            />
            {isColorsLoading || isRetailersLoading ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    <DITable table={table} isPagination isHeaderFixed />
                    <TablePagination table={table} />
                    <ColorsModal
                        {...{
                            colorToSubmit,
                            setColorToSubmit,
                            unsetColorsData,
                            selectedType,
                            showColorPicker,
                            setShowColorPicker,
                            isModalOpen,
                            setIsModalOpen,
                            modalType,
                        }}
                    />
                </>
            )}
        </Box>
    );
};

export default ColorManagementTab;
